export default {
    en: {
        taskSearch: 'Task Name/Control Policy/Camera Name',
        faceRecognition: 'Face Recognition',
        personnelBehavior: 'Personnel Behavior',
        tableDetection: 'Table Detection',
        kitchenware: 'Kitchenware',
        validTime: 'Valid Time',
        total: 'Total {msg} Items',
        taskName: 'Task Name',
        deviceName: 'Device',
        operation: 'Option',
        zoneName: 'Area Name',
        status: 'Status',
        creator: 'Creator',
        effect: 'Running',
        noEffective: 'Disabled',
        abnormal: 'Abnormal',
        confirmDeleteAttr: 'Are you sure to delete the task？',
        cancel: 'Cancel',
        delete: 'Delete',
        deletedSuccessfully: 'Deleted successfully',
        deleteMsg: 'Are you sure to delete this task?',
        deleteEnter: 'The task is in progress, please pause the task and try to delete the task again',
        creationTime: 'Creation Time',
        alarmType: 'Task Type',
        queueNumber: 'Queue Length',
        queueTime: 'Waiting Time',
        always: 'Always',
        taskResult: 'Result',
        animalsInsects: 'Animals & Pest',
        similarity: 'Similarity',
        route: 'Route',
        developRoute: 'Generate Route',
        device: 'Device',
        reults: 'results',
        halfMonth: 'Last 15 days',
        start: 'start',
        end: 'end',
        week: 'Last week',
        alarmSearch: 'Portrait Name',
        type: 'Alert Type',
        critical: 'Critical',
        major: 'Major',
        minor: 'Minor',
        all: 'All',
        level: 'Level',
        title: 'Select results to develop route',
        headNod: 'Head',
        headShoulders: 'Head and Shoulder',
        success: 'success',
        crossLineTips: 'Select the flow of people leaving the direction',
    },
    zh: {
        taskSearch: '任务名称/布控策略/摄像头名称',
        faceRecognition: '人脸识别',
        personnelBehavior: '人员行为检测',
        tableDetection: '餐桌检测',
        kitchenware: '盒盖检测',
        animalsInsects: '害虫检测',
        taskName: '任务名称',
        deviceName: '设备名称',
        zoneName: '所属区域',
        status: '任务状态',
        creator: '创建人',
        effect: '启用',
        noEffective: '停用',
        abnormal: '异常',
        confirmDeleteAttr: '确认删除?',
        cancel: '取消',
        operation: '操作',
        delete: '确认',
        deletedSuccessfully: '删除成功',
        total: '总共 {msg} 条',
        deleteMsg: '确定删除这个任务吗？',
        deleteEnter: '该任务正在执行中，请暂停任务后再次尝试删除任务操作',
        creationTime: '创建时间',
        validTime: '有效时间',
        alarmType: '告警类型',
        queueNumber: '排队人数',
        queueTime: '排队时间',
        always: '永久生效',
        taskResult: '结果',
        similarity: '相似度',
        route: '轨迹',
        developRoute: '轨迹还原',
        device: '视频源',
        reults: '条',
        halfMonth: '近15天',
        week: '近一周',
        start: '开始',
        end: '结束',
        alarmSearch: '人像名称',
        type: '告警类型',
        critical: '重度',
        major: '中度',
        minor: '轻度',
        all: '全部',
        level: '告警等级',
        title: '选择结果开发路线',
        headNod: '人头点',
        headShoulders: '头肩',
        success: '成功',
        crossLineTips: '请选择出口方向',
    },
};
